// extracted by mini-css-extract-plugin
export var copyIcon = "_yp-2";
export var discountCard = "_yp-0";
export var discountCode = "_yp-3";
export var discountContent = "_yp-1";
export var loadingCard = "_yp-4";